class SmartMarquee extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.classList.add("is-looping");

    const direction = this.getAttribute("direction");
    if (direction === "reverse") {
      this.setAttribute("data-direction", "reverse");
    }

    window.addEventListener("resize", () => {
      this.classList.add("is-looping");
    });
  }
}

customElements.define("smart-marquee", SmartMarquee);
